import { Component, Input, Output, EventEmitter } from '@angular/core';
import {View} from '@shared/components/view-toggle-button/view.enum';
import { ProjectListType } from '../project-list-type.enum';
import { ProjectType } from '@project/shared/project-type.enum';
import { Router } from '@angular/router';
import { UserService } from '@user/user.service';
import { ROLE_TYPE } from '@user/role-type';
import { Program } from '@program/shared/program.model';

@Component({
  selector: 'oes-shared-project-action',
  templateUrl: './shared-project-action.component.html',
  styleUrls: ['./shared-project-action.component.scss']
})
export class SharedProjectActionComponent {
  @Input() selectedProjects = [];
  @Input() listType: ProjectListType = ProjectListType.MAIN;
  @Input() program: Program;
  @Output() exportCsv: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() changeStageBulk: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() installSampleProject: EventEmitter<boolean> = new EventEmitter<boolean>();
  projectListType = ProjectListType;
  projectType = ProjectType;
  view = View;

  constructor(private _router: Router, private _userService: UserService) {
  }

  /**
   * DEF-VDA-006: from Program > Assets the sponsor is creating INSIDE a program, so pass it on —
   * `ProjectCreateComponent.getParams` validates `programId` against the programs the caller can
   * create in and seeds the form with it. Without this the param had no caller at all and the
   * Program field opened empty, even though this list is already scoped to one program.
   */
  public newProject(projectType: ProjectType) {
    const queryParams: { projectType: ProjectType; programId?: string } = { projectType };
    if (this.program?.id) {
      queryParams.programId = this.program.id;
    }
    this._router.navigate(['/oes/projects/create'], { queryParams });
  }

  isAdminUser() {
    return this._userService.hasRole(ROLE_TYPE.ORGANIZATION_ADMIN);
  }

  emitInstallSampleProject() {
    this.installSampleProject.emit(true);
  }
}
